import React, {Component} from 'react';

import './RemedialTrainingResponse.scss';
import CustomForm from "../../../../shared/components/form/CustomForm";
import {validateRequired} from "../../../../shared/components/form/ValidationFunctions";
import classNames from 'classnames'

class CallTrackingResponse extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFormOpened: false
    }
  }

  get value() {
    return this.props.value && this.props.value.list || []
  }

  get isEdit() {
    return this.props.isEdit !== false
  }

  componentDidMount() {
    this.props.onValueChange && this.props.onValueChange(this.props.name, {
      ...this.props.value,
      isValid: this.props.value && !!this.props.value.list && !!this.props.value.list.length,
    });
  }

  get formConfig() {
    return {
      fields: {
        call_type: {
          type: 'text',
          label: this.props.element.call_type_label,
          rules: [validateRequired(this.props.element.call_type_label)]
        },
        time: {
          type: 'time',
          label: this.props.element.time_label,
          rules: [validateRequired(this.props.element.time_label)]
        },
        location: {
          type: 'textarea',
          label: this.props.element.location_label,
          rules: [validateRequired(this.props.element.location_label)]
        },
        arrest: {
          type: 'boolean',
          label: this.props.element.was_there_arrest_label,
          // rules: [validateRequired( this.props.element.remedial_training_successful_label)]
        },
        overview: {
          type: 'textarea',
          label: this.props.element.overview_label
        },
        rating: {
          type: 'select',
          label: this.props.element.rating_label,
          value: 'value',
          optionLabel: 'label',
          options: [{
            value: 'acceptable',
            label: 'Acceptable'
          }, {
            value: 'unacceptable',
            label: 'Unacceptable'
          }, {
            value: 'needsImprovement',
            label: 'Needs improvement'
          }]
          // rules: [validateRequired( this.props.element.continue_remedial_training_label)]
        }
      }
    }
  }

  openForm() {
    this.setState({
      isFormOpened: true
    })
  }

  onAddLog(log) {
    this.props.onValueChange(this.props.name, {
      ...this.props.value,
      isValid: true,
      list: [...this.value, log]
    });
    this.setState({
      isFormOpened: false
    })
  }

  removeItem(index) {
    let copyVal = [...this.value];
    copyVal.splice(index, 1);
    this.props.onValueChange(this.props.name, {
      ...this.props.value,
      isValid: !!copyVal.length,
      list: copyVal
    })
  }

  render() {
    return (
      <div className={classNames({"remedial-training-response": true, 'preview': !this.isEdit})}>
        <div className="remedial-training-title">
          {this.props.element.title_label}
        </div>
        {this.value.map((val, index) => (
          <div className="remedial-training-response-item" key={val.name}>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.call_type_label}
              </div>
              <div className="rt-value">
                {val.call_type}
              </div>
            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.time_label}
              </div>
              <div className="rt-value">
                {val.time}
              </div>
            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.location_label}
              </div>
              <div className="rt-value">
                {val.location}
              </div>
            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.was_there_arrest_label}
              </div>
              <div className="rt-value">
                {val.arrest ? 'YES' : 'NO'}
              </div>
            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.overview_label}
              </div>
              <div className="rt-value">
                {val.overview}
              </div>

            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.rating_label}
              </div>
              <div className="rt-value">
                {val.rating}
              </div>
            </div>
            {this.isEdit && (
              <div className="rt-item">
                <button className="button danger small" type="button" onClick={() => this.removeItem(index)}>
                  <i className="fa fa-trash"/> Delete call log
                </button>
              </div>
            )}
          </div>
        ))}
        {
          !this.state.isFormOpened && this.isEdit && (
            <div className="text-right add-rt">
              <button className="button primary small" type="button" onClick={() => this.openForm()}>
                <i className="fa fa-plus"/> Add call log
              </button>
            </div>
          )
        }

        {this.state.isFormOpened && this.isEdit && (
          <div>
            <CustomForm
              config={this.formConfig}
              saveLabel={'Add'}
              saveIcon={'fa fa-plus'}
              onSubmit={(log) => this.onAddLog(log)}
            />
          </div>
        )}
      </div>
    )
  }
}

export default CallTrackingResponse;
